<div class="full-screen-modal">
  <header>
    <h2 class="title">{{headerText}}</h2>
    <i class="close-btn material-icons" (click)="closeView()">close</i>
  </header>
  <div class="main-content">
    <div class="card first-form-container">
      <div class="inputs-container">
        <div class="input-field">
          <span class="input-prefix" [class.active]="newAmount">₹</span>
          <input #amount id="amount" name="amount" type="tel" [textMask]="rupeeCommaNumberMask" pattern="^[1-9][0-9,]*$"
            [placeholder]="newAmount | RupeeCurrencyPipe" required autofocus [(ngModel)]="newAmount" #amount="ngModel"
            (ngModelChange)="updatePrice($event)" autofocus>
          <label class="active" for="amount">Enter new amount</label>
          <div class="help-text error" *ngIf="!productPriceInRange && !emiPlans?.length">
            Please select an amount between {{minAllowedVoucherAmount | RupeeCurrencyPipe}} and
            {{maxAllowedVoucherAmount | RupeeCurrencyPipe}}
          </div>
        </div>
        <div class="input-field" *ngIf="productPriceInRange && emiPlans?.length">
          <label class="active">Select EMI Plan</label>
          <div class="emi-list-wrapper">
            <div class="emi-option" *ngFor="let emi of emiPlans"
              [class.selected]="emi.NumberOfMonths === selectedEMIPlan">
              <div class="offer" *ngIf="emi.SubventionInterestCashback">on offer</div>
              <input id="{{emi.NumberOfMonths}}" type="radio" [value]="emi.NumberOfMonths" [(ngModel)]="selectedEMIPlan"
                (ngModelChange)="selectMonths(selectedEMIPlan)" />
              <label for="{{emi.NumberOfMonths}}">
                <div class="amount">{{emi.TotalMonthlyAmount | RupeeCurrencyPipe}}/m</div>
                <div class="months">{{emi.NumberOfMonths}} months</div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <div class="info reward"
      *ngIf="selectedPlan && selectedPlan.SubventionInterestCashback && (selectedPlan.TotalMonthlyAmount - selectedPlan.EffectiveEmiAmount) > 0">
      <img class="offer-tag" src="/assets/images/ocd/offer-tag.png" />
      <p>
        <span class="offer-text">OFFER:</span> You get a cashback of
        <span [textContent]="(selectedPlan.TotalMonthlyAmount - selectedPlan.EffectiveEmiAmount) | RupeeCurrencyPipe"></span>
        into your bank account with every EMI repayment, within 2-3 business days for {{selectedPlan.NumberOfMonths}}
        months tenure only.
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn zest-btn primary" [disabled]="!(productPriceInRange && selectedPlan)"
        (click)="updateLoanAmount(selectedPlan)">UPDATE VOUCHER</button>
    </div>
  </footer>
</div>